import React from 'react';

const labelClass = 'text-xs font-semibold uppercase tracking-wider text-gray-500';
const inputClass = 'input-modern';

const SECTION_META = [
  { key: 'hero', label: 'Hero Section', showBg: false, showRightImageToggle: true },
  { key: 'countdown', label: 'Countdown Section', showBg: true },
  { key: 'whyAttend', label: 'Why Attend Section', showBg: true },
  { key: 'speakers', label: 'Speakers Section', showBg: true },
  { key: 'registration', label: 'Registration Section', showBg: true },
];

const SectionToggle = ({ checked, onChange, label }) => (
  <label className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer">
    <input
      type="checkbox"
      checked={checked !== false}
      onChange={(e) => onChange(e.target.checked)}
      className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
    />
    {label}
  </label>
);

const WebinarPageSectionsEditor = ({ form, setForm }) => {
  const pageSections = form.pageSections || {};
  const eventDetailIcons = form.eventDetailIcons || { date: '📅', time: '🕘', platform: '💻' };

  const updateSection = (sectionKey, field, value) => {
    setForm((prev) => ({
      ...prev,
      pageSections: {
        ...prev.pageSections,
        [sectionKey]: {
          ...(prev.pageSections?.[sectionKey] || {}),
          [field]: value,
        },
      },
    }));
  };

  const updateEventIcon = (field, value) => {
    setForm((prev) => ({
      ...prev,
      eventDetailIcons: {
        ...(prev.eventDetailIcons || {}),
        [field]: value,
      },
    }));
  };

  return (
    <div className="space-y-6">
      <div className="p-3 rounded-xl bg-purple-50 dark:bg-purple-900/20 text-sm text-purple-800 dark:text-purple-200">
        Enable or disable page sections, change hero image, section backgrounds, and event detail icons.
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-dark-600 p-4 space-y-4">
        <h3 className="text-sm font-bold text-gray-800 dark:text-gray-200">Event Detail Icons (Why Attend cards)</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className={labelClass}>Date icon</label>
            <input className={inputClass} value={eventDetailIcons.date || ''} onChange={(e) => updateEventIcon('date', e.target.value)} placeholder="📅" />
          </div>
          <div>
            <label className={labelClass}>Time icon</label>
            <input className={inputClass} value={eventDetailIcons.time || ''} onChange={(e) => updateEventIcon('time', e.target.value)} placeholder="🕘" />
          </div>
          <div>
            <label className={labelClass}>Platform icon</label>
            <input className={inputClass} value={eventDetailIcons.platform || ''} onChange={(e) => updateEventIcon('platform', e.target.value)} placeholder="💻" />
          </div>
        </div>
      </div>

      {SECTION_META.map(({ key, label, showBg, showRightImageToggle }) => {
        const section = pageSections[key] || {};
        return (
          <div key={key} className="rounded-2xl border border-gray-200 dark:border-dark-600 p-4 space-y-4 bg-gray-50/40 dark:bg-dark-900/20">
            <div className="flex items-center justify-between gap-3">
              <h3 className="text-sm font-bold text-gray-800 dark:text-gray-200">{label}</h3>
              <SectionToggle
                label={section.isActive !== false ? 'Active' : 'Disabled'}
                checked={section.isActive !== false}
                onChange={(checked) => updateSection(key, 'isActive', checked)}
              />
            </div>

            {showRightImageToggle && (
              <SectionToggle
                label="Show right side image on website"
                checked={section.showRightImage !== false}
                onChange={(checked) => updateSection(key, 'showRightImage', checked)}
              />
            )}

            {showBg && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div>
                  <label className={labelClass}>BG color from</label>
                  <input className={inputClass} value={section.bgFrom || ''} onChange={(e) => updateSection(key, 'bgFrom', e.target.value)} placeholder="#1a0533" />
                </div>
                <div>
                  <label className={labelClass}>BG color via (optional)</label>
                  <input className={inputClass} value={section.bgVia || ''} onChange={(e) => updateSection(key, 'bgVia', e.target.value)} placeholder="#2d1250" />
                </div>
                <div>
                  <label className={labelClass}>BG color to</label>
                  <input className={inputClass} value={section.bgTo || ''} onChange={(e) => updateSection(key, 'bgTo', e.target.value)} placeholder="#1a1040" />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default WebinarPageSectionsEditor;
